// src/components/TabBar.tsx
import React from "react";

export default function TabBar({
  tabs,
  active,
  onChange,
  leftPad = 20,                       // default left padding
}: {
  tabs: string[];
  active: number;
  onChange: (i: number) => void;
  leftPad?: number;
}) {
  return (
    <div
      className="flex items-end gap-4 border-b border-[#e6e6e6] px-1 pt-3 overflow-x-auto scrollbar-none"
      style={{ paddingLeft: leftPad }}
    >
      {tabs.map((t, i) => (
        <button
          key={t}
          className={`relative inline-flex items-center bg-transparent border-0 outline-0 py-3 uppercase font-extrabold text-[12px] tracking-[0.05em] whitespace-nowrap ${
            i === 0 ? "" : "ml-4"
          } ${i === active ? "text-[#121212]" : "text-[#8a8a8a]"}`}
          onClick={() => onChange(i)}
        >
          {t}
          <span
            className={`absolute left-0 right-0 -bottom-[1px] h-[2px] rounded ${
              i === active ? "bg-[#121212]" : "bg-transparent"
            }`}
          />
        </button>
      ))}
    </div>
  );
}
